import React from "react";
import "./Display.css";
import { Link } from "react-router-dom";
import { useState } from "react";
import { triggerBase64Download } from "react-base64-downloader";
import bg from "../assets/images/background.png";

export default function Display({ imgSrc, imgPredict, setImgSrc }) {
  const [imgShow, setImgShow] = useState("origin");
  const [imgDownload, setImgDownload] = useState(imgSrc);
  const dataShowImg = [
    {
      id: "001",
      name: "origin",
      title: "Original",
      src: imgSrc,
    },
    {
      id: "002",
      name: "rmbg",
      title: "Removed Background",
      src: imgPredict,
    },
  ];
  const handleClick = (item) => {
    setImgShow(item.name);
    setImgDownload(item.name === "origin" ? imgSrc : imgPredict);
  };

  const handleExit = () => {
    // const cacheStorage = await caches.open("data");
    // const cachedResponse = await cacheStorage.delete("src");
    setImgSrc("");
    // window.reload();
  };
  return (
    <div className="display">
      <div className="display-title">
        <div className="display-nav">
          {dataShowImg.map((item) => {
            return (
              <div
                key={item.id}
                onClick={() => handleClick(item)}
                className={item.name === imgShow ? "active-display" : ""}
              >
                {item.title}
              </div>
            );
          })}
        </div>
        <i className="icon fa-solid fa-xmark" onClick={handleExit}></i>
      </div>

      <div className="display-img">
        <div className="ctn-img">
          <img
            src={imgShow === "origin" ? imgSrc : imgPredict}
            alt="#"
            style={{
              maxWidth: "100%",
              height: "auto",
              margin: "auto",
              display: "flex",
              alignItems:"center",
              justifyContent:"center"
            }}
          />
        </div>

        <div className="display-download">
          {/* <button><Link to={imgSrc} download target="_blank">Download</Link>></button> */}
          <button onClick={() => triggerBase64Download(imgDownload, "predict")}>
            Click to download
          </button>
          <p>Preview Image 500x408 </p>
          <button onClick={() => triggerBase64Download(imgDownload, "predict")}>
            Download HD
          </button>
          <p>Full Image 800x800</p>
        </div>
      </div>
    </div>
  );
}
